import Service from "../../Services";

const News = {
  namespaced : true,
  state : {
    form : {
      branch_id : '',
      title_th : '',
      title_en : '',
      description_en : '',
      description_th : '',
      image_path : '',
      image_path_show : '',
      image_name : '',
      publish_date : '',
      viewer : '',
      slug_url : '',
      orders : '',
      is_publish : true,
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      if (res.branch_id) {
        res.branch_id = res.branch_id.split(',')
        res.branch_id = res.branch_id.map(item => {
          return parseInt(item)
        })
      }
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        branch_id : '',
        title_th : '',
        title_en : '',
        description_en : '',
        description_th : '',
        image_path : '',
        image_path_show : '',
        image_name : '',
        publish_date : '',
        viewer : '',
        slug_url : '',
        orders : '',
        is_publish : true,
      }
    }
  },
  actions : {
    getNews({commit},{page,search,sort_date,sort_column}){
      return Service.NewsAPI.getNews(page,search,sort_date,sort_column);
    },
    showNews({commit},id){
      return Service.NewsAPI.showNews(id);
    },
    saveNews({commit},{id,data}){
      if(id){
        return Service.NewsAPI.updateNews(id,data);
      }else{
        return Service.NewsAPI.createNews(data);
      }
    },
    deleteNews({commit},id){
      return Service.NewsAPI.deleteNews(id);
    },
    setFormNews({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default News
